import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { NUMBER_SIZE } from '../../../constants/size'
import { EntityTag } from '../../Entity'
import { FileIcon, FileIconPreview } from '../../FileIcon'
import { ICON_HEIGHT_24, IconNG } from '../../Icon'
import { TableCellBase, TableCellText } from '../../Table'
import { TAG_HEIGHT } from '../../Tag'

import { isFolder } from './DocumentDraggableTableTitleCell.utils'

import * as styles from './DocumentDraggableTableTitleCell.module.css'

import InvoiceIcon from '../../../icons/invoice.svg'
import VulcavoIcon from '../../../icons/vulcavo.svg'

function DocumentDraggableTableTitleCell({
  className,
  isShort,
  item,
  showSymbols,
  textClassName,
  ...restProps
}) {
  const { t } = useTranslation()

  const IconComponent = isFolder(item) ? FileIcon : FileIconPreview

  const value = item.is_persistent ? t(item.name) : item.name

  return (
    <TableCellBase
      {...restProps}
      className={classNames(styles.titleCell, className)}
      isShort={isShort}
    >
      <IconComponent
        className={isFolder(item) ? undefined : styles.fileIcon}
        file={item}
        size={NUMBER_SIZE.size24}
      />
      <div
        className={classNames(styles.title, {
          [styles.titleInline]: showSymbols,
        })}
      >
        <TableCellText className={textClassName} value={value} />
        {item?.is_invoice ? (
          showSymbols ? (
            <IconNG
              Icon={InvoiceIcon}
              className={styles.invoiceIconInline}
              size={ICON_HEIGHT_24}
            />
          ) : (
            <EntityTag
              Icon={InvoiceIcon}
              className={styles.invoiceTag}
              height={TAG_HEIGHT.height28}
              name={t('DocumentMarkAsInvoice.TagKey')}
              tooltip={t('DocumentMarkAsInvoice.MarkedAsInvoiceKey')}
            />
          )
        ) : null}
        {item?.is_sent_to_vulcavo ? (
          showSymbols ? (
            <IconNG
              Icon={VulcavoIcon}
              className={styles.vulcavoIconInline}
              size={ICON_HEIGHT_24}
            />
          ) : (
            <EntityTag
              Icon={VulcavoIcon}
              className={styles.vulcavoTag}
              height={TAG_HEIGHT.height28}
              name={t('DocumentMarkAsVulcavo.TagKey')}
              tooltip={t('DocumentMarkAsVulcavo.MarkedAsVulcavoKey')}
            />
          )
        ) : null}
      </div>
    </TableCellBase>
  )
}

export default DocumentDraggableTableTitleCell
